var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "client-single client-view-project" }, [
      _c("div", { staticClass: "m-content" }, [_vm._v("\nxxx\n        ")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }